module.exports = __webpack_public_path__ + "static/media/div6.8583b02e.jpg";